export default "https://cdn.questicon.mathletics.com/assets/images/audioIcon-8b35f4721bfa257c7b459106447fc360.svg";